<!-- client section ends -->
<section class="section client bg1 backgroundbg">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto"
			>
				<div class="logos">
					<h3 class="fontsize12 mb-0 semibold text-capitalize">
						OUR CLIENTS INCLUDE…
					</h3>
					<owl-carousel-o [options]="clientslider">
						<ng-container>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/dnour.svg"
											alt="ecommerce website design dubai"
											width=""
											height=""
											class="img-fluid"
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/crystal.svg"
											alt="ecommerce website design dubai"
											height=""
											class="img-fluid"
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/miniaar.svg"
											alt="ecommerce website design dubai"
											height=""
											class="img-fluid"
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/bni.svg"
											alt="ecommerce website design dubai"
											height=""
											class="img-fluid"
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/angle.svg"
											alt="ecommerce website design dubai"
											height=""
											class="img-fluid"
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/pakhis.svg"
											alt="ecommerce website design dubai"
											height=""
											class="img-fluid"
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/drminnie.svg"
											alt="ecommerce website design dubai"
											height=""
											class="img-fluid"
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/veddentta.svg"
											alt="ecommerce website design dubai"
											height=""
											class="img-fluid"
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/autokoorosh.svg"
											alt="ecommerce website design dubai"
											height=""
											class="img-fluid"
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/fractal.svg"
											alt="ecommerce website design dubai"
											height=""
											class="img-fluid"
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/aetrio.svg"
											alt="ecommerce website design dubai"
											height=""
											class="img-fluid"
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/wrae.svg"
											alt="ecommerce website design dubai"
											height=""
											class="img-fluid"
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/beyou.svg"
											alt="ecommerce website design dubai"
											height=""
											class="img-fluid"
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
						</ng-container>
					</owl-carousel-o>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- client section ends -->
